var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-overall" } }, [
    _c(
      "div",
      { staticClass: "overall-content" },
      [
        _vm.loading
          ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "chart-container" },
          [
            _c(
              "div",
              { staticClass: "header" },
              [
                _c("FilterTool", {
                  attrs: {
                    isGraphShowing: true,
                    "keep-state-on-query-params": true,
                  },
                  model: {
                    value: _vm.filters,
                    callback: function ($$v) {
                      _vm.filters = $$v
                    },
                    expression: "filters",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chart-section" },
              [
                _c("h2", [_vm._v(_vm._s(_vm.$t("report.overall")))]),
                _vm._v(" "),
                _vm.graphData
                  ? _c("ChatCountChart", {
                      attrs: {
                        title: "Sessions Timeseries",
                        data: _vm.graphData,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("a-divider"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chart-section" },
              [
                _c("h2", [_vm._v(_vm._s(_vm.$t("report.ratingOverall")))]),
                _vm._v(" "),
                _vm.graphData
                  ? _c("RatingChart", {
                      attrs: {
                        title: "Rating Timeseries",
                        data: _vm.graphData,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("a-divider"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chart-section" },
              [
                _c("h2", [
                  _vm._v(
                    _vm._s(_vm.$t("report.chatbotSessionDurationOverall"))
                  ),
                ]),
                _vm._v(" "),
                _vm.graphData
                  ? _c("SessionDurationChart", {
                      attrs: {
                        title: "Chatbot Session Durations",
                        data: _vm.graphData,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("a-divider"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chart-section" },
              [
                _c("h2", [_vm._v(_vm._s(_vm.$t("report.trainingOverall")))]),
                _vm._v(" "),
                _vm.graphData
                  ? _c("TrainingChart", {
                      attrs: {
                        title: "Chatbot Training Status",
                        data: _vm.graphData,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("a-divider"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chart-section" },
              [
                _c("h2", [_vm._v(_vm._s(_vm.$t("report.segmentsOverall")))]),
                _vm._v(" "),
                _vm.graphData
                  ? _c("SegmentChart", {
                      attrs: {
                        title: "User Segmentation",
                        data: _vm.graphData,
                        segments: _vm.segments,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }